// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2438J","gfeWrapper":"CalendarEvent_gfeWrapper__3DhLW"};